export default {
    edit_brand_create_title: 'Crear marca',
    edit_brand_edit_title: 'Editar marca',
    edit_brand_brand_name: 'Titulo',
    edit_brand_brand_code: 'Código',
    edit_brand_brand_name_min_error: 'El titulo de la marca debe contener un mínimo de caracteres',
    edit_brand_brand_name_max_error: 'El titulo de la marca contiene un máximo de caracteres',
    edit_brand_language: 'Lenguaje',
    edit_brand_time_zone: 'Zona Horaria',
    edit_brand_brand: 'Marca',
    edit_brand_crm: 'Id. de Salesforce',
    edit_brand_crm_min_error: 'El CRN debe contener un mínimo de caracteres',
    edit_brand_internal: 'Interno',
    edit_brand_yes: 'Si',
    edit_brand_not: 'No',
    edit_brand_username: 'Usuario',
    edit_brand_username_error_min: 'El nombre de usuario debe contener un mínimo de caracteres',
    edit_brand_username_error_max: 'El nombre de usuario debe contener un máximo de caracteres',
    edit_brand_email: 'Correo',
    edit_brand_password: 'Contraseña',
    edit_brand_role: 'Rol',
    edit_brand_report_options: 'Opciones de informe',
    edit_brand_site_options: 'Opciones del sitio',
    edit_brand_no_options: 'Sin opciones',
    edit_brand_the_brand_has_been_edited: 'La marca ha sido editada',
    edit_brand_general: 'General',
    edit_brand_packages: 'Paquetes',
    edit_brand_automatic: 'Automático',
    edit_brand_manual: 'Manual',
    edit_brand_click_to_copy_password: 'Haga clic para copiar la contraseña!',
    edit_brand_the_password_was_copied: 'La contraseña fue copiada',
    edit_brand_package: 'Paquete',
    edit_brand_select: 'Seleccionar...',
    edit_brand_crm_max_error: 'El Id. de Salesforce debe contener un máximo de caracteres',
    edit_brand_promiles_username: 'Nombre de usuario de Promiles',
    edit_brand_promiles_email: 'Correo electrónico de Promiles',
    edit_brand_fuel_card_company_code: 'Código de la tarjeta de combustible',
    edit_brand_additional_info: 'Información Adicional',
    edit_brand_error_username: 'El nombre de usuario debe contener sólo letras minúsculas y números, los espacios no son válidos',
    edit_brand_verify_terms_conditions: 'Verificar los términos y condiciones',
    edit_brand_verify_terms_conditions_message: 'Al activar esta opción (SÍ) se requiere por parte de los usuarios la aceptación de términos y condiciones durante el proceso de autenticación. Una vez aceptados los T&C, el sistema no vuelve a solicitarlo',
    edit_brand_speed_limit_engine: 'Límite de velocidad del motor',
    edit_brand_rgeo_engine: 'Motor Rgeo',
    edit_brand_osm_with_fallback_google: "OSM con acceso a Google",
    edit_brand_osm_only: "Sólo OSM",
    edit_brand_web_service_integration: "WEX EFS",
    edit_brand_status: "Estado",
    edit_brand_validate_credentials: "Validar Credenciales",
    edit_brand_active: "Activo",
    edit_brand_inactive: "Inactivo",
    edit_brand_fuel_card_integrations: "Integración de tarjetas de combustible",
    edit_brand_wex_credencials_success: "Las credenciales son válidas",
    edit_brand_wex_credencials_error: "Las credenciales no son válidas",
    edit_brand_wex_credencials_message: "Las credenciales deben validarse",
    edit_brand_promiles: "Promiles",
    edit_brand_fuel_cards: "Tarjetas de combustible",
    edit_brand_web_services_status: "Estado de Servicios Web",
    edit_brand_master_company: "Compañía Maestra",
    create_delaer_brand: "Marca",
    edit_brand_tos_url: "URL de términos de servicio",
    edit_brand_domains: 'Dominios',
    edit_brand_help_url: 'URL de ayuda',
    edit_brand_address: 'Dirección',
    edit_brand_phone: 'Teléfono',
    edit_brand_login_background_image: 'Imagen de fondo de inicio de sesión',
    edit_brand_login_background_color: 'Color de fondo de inicio de sesión',
    edit_brand_login_company_logo: 'Logo de la empresa de inicio de sesión',
    edit_brand_favicon: 'Favicon',
    edit_brand_home_page_url: 'URL de la página de inicio',
    edit_brand_error_creating_brand: 'Error al crear la marca',
    edit_brand_the_brand_has_been_created: 'La marca ha sido creada',
    edit_brand_in_app_logo: 'Logo en la aplicación',
};